// auto-generated - do not edit

export const MINIMUM_BROWSER_VERSIONS = {
  "chrome": 143,
  "edge": 143,
  "firefox": 145,
  "safari": 26
};
